import { Typography } from "@mui/material";
import { roleColors } from "../../../../ui/colors";

interface Props {
  isResidential: boolean;
}

export const JobCardBadge: React.FC<Props> = ({ isResidential }) => {
  const currentRole = isResidential ? roleColors.residential : roleColors.commercial;

  return (
    <Typography
      variant="caption"
      sx={{
        color: currentRole.base,
        fontWeight: 700,
        fontSize: { xs: "0.62rem", sm: "0.72rem" },
        textTransform: "capitalize",
      }}
    >
      Job scope: {isResidential ? "Residential" : "Commercial"}
    </Typography>
  );
};
